import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, interval } from 'rxjs';
import { DialogService } from '../dialog-service/dialog-service.service';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogBackendServiceUnavailableComponent } from 'src/app/components/dialog-windows/dialog-backend-service-unavailable/dialog-backend-service-unavailable/dialog-backend-service-unavailable.component';

@Injectable({
    providedIn: 'root'
})
export class HealthService {
    dialogRef: MatDialogRef<DialogBackendServiceUnavailableComponent, any> =
        null;

    constructor(
        private http: HttpClient,
        private dialogService: DialogService
    ) {
        //interval(60 * 1000).subscribe(() => this.checkAllMicroserviceHealth());
        //this.checkAllMicroserviceHealth();
    }

    readonly SWARM_API = '/proxy/api/v0/';
    readonly health_endpoint = '/health';
    readonly services = [
        'userservice',
        'productservice',
        'pcssoservice',
        'smtpservice',
        'fileservice'
    ];

    checkAllMicroserviceHealth(): void {
        const requests = [];
        for (let service of this.services) {
            requests.push(this.sendHealthcheck(service));
        }
        forkJoin(requests).subscribe(
            (res) => {
                if (this.dialogRef != null) {
                    this.dialogRef.close();
                    this.dialogRef = null;
                }
            },
            (error) => {
                if (this.dialogRef == null) {
                    this.dialogRef =
                        this.dialogService.openBackendServiceUnavailabeDialog();
                }
            }
        );
    }

    sendHealthcheck(service: string): Observable<any> {
        const url = `${this.SWARM_API}${service}${this.health_endpoint}`;
        return this.http.get(url);
    }
}
